import { actionName } from './utils';

export const UPDATE_FILTERS = actionName('UPDATE_FILTERS');
export const RESET_FILTERS = actionName('RESET_FILTERS');
